import script from "./CategoryBrowserDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryBrowserDialog.vue?vue&type=script&setup=true&lang=js"

import "./CategoryBrowserDialog.vue?vue&type=style&index=0&id=57268096&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57268096"]])

export default __exports__